import { useDispatch } from 'react-redux';

export default function useStoreHealthPlan() {
    const dispatch = useDispatch();

    const executor = (healthPlan) => {
        return dispatch({
            type: 'SET_HEALTH_PLAN',
            payload: healthPlan,
        });
    };

    return executor;
};